import EditMenu from 'components/EditMenu';
import IconCounter from 'components/IconCounter';
import MenuButton from 'components/MenuButton';
import SectionHeadline from 'components/SectionHeadline';
import { FireModelType } from 'models/FireModel';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { ROUTE_FIRE } from 'utils/constants/routes';

interface FiresListProps {
  fires: FireModelType[];
  organizationId: number;
  handleDeleteFire: (fire: FireModelType) => void;
}

const FiresList: React.FC<FiresListProps> = ({ fires, organizationId, handleDeleteFire }) => {
  const intl = useIntl();

  if (!fires.length) {
    return null;
  }

  return (
    <div className="l-project-wrapper">
      <div className="l-pro">
        <SectionHeadline
          title={<FormattedMessage id="All fires" />}
          lessPaddingTop={true}
        />
        <div className="project-list">
          {fires.map((fire) => (
            <article className="project-card-small" key={fire.id}>
              <div className="project-card-small__body">
                <Link to={ROUTE_FIRE + '/' + organizationId + '/' + fire.id}>
                  <div className="project-card-small__headline">
                    {fire.project_name}
                  </div>
                </Link>
                <div className="project-card-small__footer">
                  <div className="project-card-small__left-footer">
                    <IconCounter
                      value={fire.painpoints_count || 0}
                      label={intl.formatMessage({ id: 'Painpoints' })}
                      iconName="clipboard"
                    />

                    <IconCounter
                      value={fire.benchmarks_count || 0}
                      label={intl.formatMessage({ id: 'Benchmarks' })}
                      iconName="detail"
                    />

                    <IconCounter
                      value={fire.hypotheses_count || 0}
                      label={intl.formatMessage({ id: 'Hypotheses' })}
                      iconName="bulb"
                    />
                  </div>
                  <EditMenu
                    bottomRight={true}
                    label={intl.formatMessage({ id: 'Edit' })}
                  >
                    <MenuButton
                      label={intl.formatMessage({ id: 'Remove' })}
                      iconName="bin"
                      onClick={() => handleDeleteFire(fire)}
                    />
                  </EditMenu>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FiresList ;
